import { userDocuments } from '@toggle/toggle';

import { apiFetch } from '~/utils/api-fetch/apiFetch';

import { UploadedFile } from '../useUserUpload/use-user-upload.types';

export const uploadFiles = async (
  files: UploadedFile[],
  signal?: AbortSignal
) => {
  const formData = new FormData();

  files.forEach(file => {
    formData.append(file.field_name, file.fileData);
  });

  return apiFetch(userDocuments.postUploadFiles.path, {
    method: 'post',
    body: formData,
    schema: userDocuments.postUploadFiles.schema,
    signal,
  });
};
